<template>
  <div>
    <Form label-position="top">
      <FormItem :label="`${typeTitle}类型:`" v-if="!assignType">
        <RadioGroup v-model="dataConfig.userType" @on-change="userTypeChange">
          <Radio :label="0" :disabled="isDisable">不添加抄送人</Radio>
          <Radio :label="1" :disabled="isDisable">指定人员</Radio>
          <Radio :label="2" :disabled="isDisable">指定部门</Radio>
          <Radio :label="3" :disabled="isDisable">指定角色</Radio>
          <Radio :label="4" :disabled="isDisable" v-if="!isCopyerDepartmentHidden">部门主管</Radio>
          <Radio :label="5" :disabled="isDisable">直属主管</Radio>
        </RadioGroup>
      </FormItem>
      <div>
        <div v-show="dataConfig.userType == 1">
          <div v-if="!isDisable">
            <Button
            :icon="personIsEdit ? 'ios-create' : 'md-add'"
            type="primary"
            @click="openPersonModal"
          >
            {{ personIsEdit ? '修改成员' : '添加成员' }}
          </Button>
          <a class="clearList" @click="clearList('person')">清空</a>
          </div>
          <selectShowList :list="list.person" @on-delete-item="personDel" :isDisable="isDisable" />
        </div>
        <div v-show="dataConfig.userType == 2">
          <div v-if="!isDisable">
            <Button
            :icon="departmentIsEdit ? 'ios-create' : 'md-add'"
            type="primary"
            @click="openDepartmentModal"
          >
            {{ departmentIsEdit ? '修改部门' : '添加部门' }}
          </Button>
          <a class="clearList" @click="clearList('department')">清空</a>
          </div>
          <selectShowList
            type="department"
            :list="list.department"
            @on-delete-item="departmentDel"
          />
        </div>
        <div v-show="dataConfig.userType == 3">
          <div v-if="!isDisable">
            <Button
            :icon="roleIsEdit ? 'ios-create' : 'md-add'"
            type="primary"
            @click="openRoleModal"
          >
            {{ roleIsEdit ? '修改角色' : '添加角色' }}
          </Button>
          <a class="clearList" @click="clearList('role')">清空</a>
          </div>
          <selectShowList :list="list.role" @on-delete-item="roleDel" />
        </div>
        <!-- 如果是部门主管 -->
        <div v-show="dataConfig.userType == 4">
          <FormItem :label="`${typeTitle}的`">
            <Select
              v-model="bmDirector"
              style="width: 200px"
              @on-change="bmDirectorChange"
              transfer
              :disabled="isDisable"
            >
              <Option v-for="(item, index) in 20" :key="index" :value="index.toString()">
                {{ index == 0 ? '直接主管' : `${item}级主管` }}
              </Option>
            </Select>
          </FormItem>
        </div>
        <!-- 如果是直属主管 -->
        <div v-show="dataConfig.userType == 5">
          <FormItem :label="`${typeTitle}的`">
            <Select
              transfer
              v-model="zsDirector"
              style="width: 200px"
              @on-change="zsDirectorChange"
              :disabled="isDisable"
            >
              <Option v-for="(item, index) in 20" :key="index" :value="index.toString()">
                {{ index == 0 ? '直属主管' : `${item}级主管` }}
              </Option>
            </Select>
          </FormItem>
        </div>
      </div>
    </Form>
    <employees-dialog
      :multiple="multiple"
      :visible.sync="personVisible"
      :selected="list.person"
      @change="surePerson"
    />
    <departmentDialog
      :multiple="multiple"
      :selected="list.department"
      :visible.sync="departmentVisible"
      @change="sureDepartment"
    />
    <roleDialog
      :multiple="multiple"
      :visible.sync="roleVisible"
      :selected="list.role"
      @change="sureRole"
    />
  </div>
</template>
<script>
import {
  employeesDialog,
  departmentDialog,
  roleDialog,
  selectShowList
} from './components';
import { userTypeMap } from './config';
export default {
  name: 'approverInfo',
  components: {
    selectShowList,
    employeesDialog,
    departmentDialog,
    roleDialog
  },
  props: {
    assignType: { // 是否是指定类型
      type: Boolean,
      default: false
    },
    isDisable: {
      type: Boolean,
      default: false
    },
    typeTitle: {
      type: String,
      default: '',
      required: true
    },
    needSort: {
      type: Boolean,
      default: true
    },
    needDealwith: {
      type: Boolean,
      default: true
    },
    dataConfig: {
      type: Object,
      default: () => ({})
    },
    multiple: { // 多选
      type: Boolean,
      default: false
    },
    isCopyerDepartmentHidden: { // 是否隐藏部门主管
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      personVisible: false,
      departmentVisible: false,
      roleVisible: false,
      list: {
        person: [], // 人员
        department: [], // 部门
        role: [] // 角色
      },
      bmDirector: 1, // 部门主管
      zsDirector: 1 // 直属主管
    };
  },
  computed: {
    personIsEdit() {
      return this.list.person && this.list.person.length > 0;
    },
    departmentIsEdit() {
      return this.list.department && this.list.department.length > 0;
    },
    roleIsEdit() {
      return this.list.role && this.list.role.length > 0;
    }
  },
  methods: {
    openPersonModal() {
      this.personVisible = true;
    },
    openDepartmentModal() {
      this.departmentVisible = true;
    },
    openRoleModal() {
      this.roleVisible = true;
    },
    personDel(deleteItem) {
      const { id } = deleteItem;
      const list = this.list.person;
      const newList = list.filter(i => i.id != id);
      this.list = { ...this.list, person: [...newList] };
    },
    departmentDel(deleteItem) {
      const { id } = deleteItem;
      const list = this.list.department;
      const newList = list.filter(i => i.id != id);
      this.list = { ...this.list, department: [...newList] };
    },
    roleDel(deleteItem) {
      const { id } = deleteItem;
      const list = this.list.role;
      const newList = list.filter(i => i.id != id);
      this.list = { ...this.list, role: [...newList] };
    },
    clearList(type) {
      this.list = { ...this.list, [type]: [] };
    },
    surePerson(data) {
      this.list = { ...this.list, person: data };
      this.personVisible = false;
    },
    sureDepartment(data) {
      this.list = { ...this.list, department: data };
      this.departmentVisible = false;
    },
    sureRole(data) {
      this.list = { ...this.list, role: data };
      this.roleVisible = false;
    },
    userTypeChange(value) {
      // 如果不添加抄送人，不进行下面操作
      if (value == 0) {
        return true;
      }
      const { nodeExecUsersName } = userTypeMap[value];
      if ([1, 2, 3].includes(value)) {
        const ids = this.list[nodeExecUsersName].map(item => {
          // 当是部门的时候，后端要 relationId
          return value == 2 ? item.relationId : item.id;
        });
        this.dataConfig.nodeExecUsers = ids;
        this.dataConfig.nodeUserList = this.list[nodeExecUsersName];
        return true;
      }
      this.dataConfig.nodeExecUsers = [this[nodeExecUsersName]];
      this.dataConfig.nodeUserList = [];
    },
    bmDirectorChange(value) {
      if (this.dataConfig.userType == 4) {
        this.dataConfig.nodeExecUsers = [value];
      }
    },
    zsDirectorChange(value) {
      if (this.dataConfig.userType == 5) {
        this.dataConfig.nodeExecUsers = [value];
      }
    },
    initData(dataConfig) {
      const { userType } = dataConfig;
      // 如果不添加抄送人，不进行下面操作
      if (userType == 0) {
        return true;
      }
      const { nodeExecUsersName } = userTypeMap[userType];
      if ([1, 2, 3].includes(userType)) {
        this.list = {
          ...this.list,
          [nodeExecUsersName]: dataConfig.nodeUserList || []
        };
        return true;
      }
      this[nodeExecUsersName] = dataConfig.nodeExecUsers[0] || 1;
    }
  },
  created() {
    this.initData(this.dataConfig);
  }
};
</script>
<style lang="less" scoped>
.clearList {
  margin: 0 10px;
}
</style>
